import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  Table,
  TablePagination,
  TableCell,
  TableBody,
  TableHead,
  TableRow,
  Checkbox,
  Card,
} from "@material-ui/core";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import ValidatedDatePicker from "../../compartidos/ValidatedDatePicker";
import DateFnsUtils from "@date-io/date-fns";
import esLocale from "date-fns/locale/es";
import moment from "moment";
import "moment/locale/es";
import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useForm } from "../../../hooks/useForm";
import { ConveniosNNXPracticas } from "./ConveniosNNXPracticas";
import {
  conveniosNNXGetPracticas,
  conveniosNNXGetPracticasActivas,
  conveniosEliminarPracticaActivasNNX,
  conveniosEliminarPracticaActivasNNXMasivo,
  conveniosEditarNnx,
  generateExcelValorizaciones,
  setActivosPorFecha,
  conveniosReactivarPracticaNNX,
  generatePDFValorizaciones
} from "../../../actions/contrataciones/contratacionesConvenios";
import { startAlerta } from "../../../actions/ui/alertas";
import BuscadorPractica from "./BuscadorPractica";
import BuscadorConvenios from "./BuscadorConvenios";
import DeleteConveniosButton from "./DeleteConveniosButton";
import DeleteConveniosMasivosButton from "./DeleteConveniosMasivosButton";
import EditConveniosButton from "./EditConveniosButton";
import { useReactToPrint } from "react-to-print";
import { TIPO_PRACTICAS_POR_FECHA } from "../../../utils/constants";
import ReactivarConveniosButton from "./ReactivarConveniosButton";
import { TablePaginationActions } from "../../compartidos/TablePaginationActions";
import { makeStyles } from "@material-ui/core/styles";
import { CONTRATACIONES_CONVENIOS_PERMISOS } from "../../../utils/permisos";
import { validarSoloUnPermiso } from '../../../helpers/permisos';

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  rootTableRow: {
    '& > *': {
      borderBottom: 'unset',
    },
  }
}));

export const ConveniosNNX = (props) => {
  const classes = useStyles();
  moment.locale("es");
  const dispatch = useDispatch();
  const childRefDesde = useRef(null);
  const childRefHasta = useRef(null);
  const componentRef = React.useRef();
  
  const isSelected = (id) => selected.indexOf(id) !== -1;

  const { dataContrato } = useSelector((state) => state.contrataciones);
  const { nnxPracticasActivas } = useSelector((state) => state.contratacionesConvenios);

  const [showTable, setShowTable] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [selected, setSelected] = useState([]);
  const [filtroFecha, setFiltroFecha] = useState(2);
  const { permisos: permisosUser } =  useSelector(state => state.auth);

  const initialValues = {
    codDesde: null,
    codHasta: null,
    fechaInicioVigencia: null,
    valorNnx: "",
  };

  const [
    formValues,
    handleInputChange,
    ,
    setearValor,
    ,
    ,
    ,
    ,
    setearVariosValores,
    ,
  ] = useForm(initialValues);

  const { codDesde, codHasta, fechaInicioVigencia, valorNnx } = formValues;

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  
  const handleSelectAllClick = (event) => {
    
    if (event.target.checked && selected.length === 0) {
      const newSelecteds = nnxPracticasActivas.filter(s => !(s.fechaReactivacionPermitida !== null && moment(s.fechaReactivacionPermitida).isSame(moment(), 'day'))).map((n) => n.idValorizacion);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, idValorizacion) => {
    const selectedIndex = selected.indexOf(idValorizacion);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, idValorizacion);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const deletePracticasActivasMasivasHandler = (fechaFin, eliminacionPerm) => {
    dispatch(conveniosEliminarPracticaActivasNNXMasivo(dataContrato.idEfectorFacturacion, selected, fechaFin,
      eliminacionPerm, setSelected));
  };

  const deletePracticasActivasHandler = (idItem, fechaFin, eliminacionPerm) => {
    dispatch(conveniosEliminarPracticaActivasNNX(dataContrato.idEfectorFacturacion, idItem, fechaFin,
      eliminacionPerm));
  };

  const reactivarPracticaHandler = (idItem) => {
    dispatch(conveniosReactivarPracticaNNX(dataContrato.idEfectorFacturacion, idItem));
  };

  const handleEditPractica = (idItem, data) => {
    dispatch(conveniosEditarNnx(dataContrato.idEfectorFacturacion, idItem, data));
  };

  const handleGetPracticas = (tipoDataPorFecha, codDesdeFiltro, codHastaFiltro, fechaDesde, fechaHasta) => {
    setSelected([]);
    setFiltroFecha(tipoDataPorFecha);
    dispatch(conveniosNNXGetPracticasActivas(dataContrato?.idEfectorFacturacion, tipoDataPorFecha, codDesdeFiltro, codHastaFiltro, fechaDesde, fechaHasta));
  }

  const resetForm = () => {
    setearVariosValores(initialValues);
    childRefDesde.current.resetValues();
    childRefHasta.current.resetValues();
  };

  const submitHandler = (e) => {
    e.preventDefault();

    const codPracticaHasta = codHasta ? codHasta.codNom : codDesde?.codNom;

    if (!codDesde) {
      dispatch(startAlerta("Ingrese un Codigo Desde.", "error"));
    } else if (codHasta?.codNom < codDesde.codNom) {
      dispatch(
        startAlerta("El Codigo Hasta debe ser mayor al Codigo Desde.", "error")
      );
    } else {
      const data = {
        idEfectorFacturacion: dataContrato?.idEfectorFacturacion,
        codPracticaDesde: codDesde?.codNom,
        codPracticaHasta,
        valorNnx: valorNnx,
        fechaInicioVigencia: fechaInicioVigencia.toLocaleDateString("en-US"),
      };

      dispatch(conveniosNNXGetPracticas(data, setShowTable));
    }
  };

  useEffect(() => {
    dispatch(conveniosNNXGetPracticasActivas(dataContrato?.idEfectorFacturacion));
  }, []);

  // VALIDATORS
  useEffect(() => {
    const fechaInicioVigenciaContrato = dataContrato?.fechaInicioVigencia;
    const fechaFinVigenciaContrato = dataContrato?.fechaFinVigencia;

    // FECHA INICIO VIGENCIA
    ValidatorForm.addValidationRule(
      "isAfterFechaInicioVigenciaContrato",
      (value) => {
        if (
          moment(value).isValid() &&
          moment(value).isBefore(moment(fechaInicioVigenciaContrato))
        ) {
          return false;
        }
        return true;
      }
    );

    // FECHA INICIO VIGENCIA
    ValidatorForm.addValidationRule(
      "isBeforeFechaFinVigenciaContrato",
      (value) => {
        if (
          moment(value).isValid() &&
          moment(value).isAfter(moment(fechaFinVigenciaContrato))
        ) {
          return false;
        }
        return true;
      }
    );
  });

  if (nnxPracticasActivas.length > 0) {
    nnxPracticasActivas.sort((a, b) => new Date(a.fechaInicioVigencia) - new Date(b.fechaInicioVigencia));
  }
  useEffect(() => {
    return () => {
      dispatch(setActivosPorFecha(TIPO_PRACTICAS_POR_FECHA.VIGENTES))
    }
  }, [])

  return (
    <React.Fragment>
      <Dialog
        fullWidth
        maxWidth="xl"
        open={showTable}
        onClose={() => setShowTable(false)}
      >
        <DialogTitle>Confirmar Practicas</DialogTitle>
        <DialogContent>
          <ConveniosNNXPracticas
            setShowTable={setShowTable}
            resetForm={resetForm}
          />
        </DialogContent>
      </Dialog>
      <Grid container spacing={2}>
        {!props.fieldsDisabled &&
          <Grid item xs={3}>
            <Card style={{ padding: "1rem" }}>
              <ValidatorForm onSubmit={submitHandler}>
                <Grid container spacing={1}>
                  <Grid item xs={8}>
                    <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                      <ValidatedDatePicker
                        fullWidth={true}
                        margin="normal"
                        label="Fecha Inicio Vigencia"
                        format="dd/MM/yyyy"
                        maxDate={moment(new Date()).add(3, "Y")}
                        okLabel="Aceptar"
                        clearLabel="Limpiar"
                        cancelLabel="Cancelar"
                        name="fechaInicioVigencia"
                        value={
                          fechaInicioVigencia !== undefined &&
                            moment(fechaInicioVigencia).isValid()
                            ? moment(fechaInicioVigencia)
                            : null
                        }
                        onChange={(e) => setearValor("fechaInicioVigencia", e)}
                        disabled={props.fieldsDisabled}
                        KeyboardButtonProps={{
                          "aria-label": "change date",
                        }}
                        validators={[
                          "required",
                          "isAfterFechaInicioVigenciaContrato",
                          "isBeforeFechaFinVigenciaContrato",
                        ]}
                        errorMessages={[
                          "La fecha de inicio de vigencia es requerida",
                          "La fecha de inicio de vigencia debe ser mayor a la fecha de inicio de vigencia del contrato",
                          "La fecha de inicio de vigencia debe ser menor a la fecha de fin de vigencia del contrato",
                        ]}
                      />
                    </MuiPickersUtilsProvider>
                  </Grid>
                  <Grid item xs={4}>
                    <TextValidator
                      fullWidth
                      margin="normal"
                      label="NNX"
                      name="valorNnx"
                      value={valorNnx.length > 0 ? valorNnx : ""}
                      onChange={handleInputChange}
                      disabled={props.fieldsDisabled}
                      validators={["required", "isFloat"]}
                      errorMessages={[
                        "El valor NNX es requerido",
                        "El valor NNX debe ser numerico",
                      ]}
                    />
                  </Grid>
                  <Grid item xs={12} style={{ marginTop: "0.5rem" }}>
                    <BuscadorPractica ref={childRefDesde} cod={codDesde} label="Código Desde" fieldsDisabled={props.fieldsDisabled} setCod={(val) => setearValor("codDesde", val)} />
                  </Grid>
                  <Grid item xs={12} style={{ marginTop: "0.5rem" }}>
                    <BuscadorPractica ref={childRefHasta} cod={codHasta} label="Código Hasta" fieldsDisabled={props.fieldsDisabled} setCod={(val) => setearValor("codHasta", val)} />
                  </Grid>
                  <Grid item xs={12} style={{ textAlign: "center" }}>
                    <Button
                      type="submit"
                      variant="contained"
                      color="primary"
                    >
                      Consultar
                    </Button>
                  </Grid>
                </Grid>
              </ValidatorForm>
            </Card>
          </Grid>
        }
        <Grid item xs={!props.fieldsDisabled ? 9 : 12}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <BuscadorConvenios
                handleSearch={handleGetPracticas}
                handlePrint={handlePrint}
                handleExportExcel={(dataPorFecha) => dispatch(generateExcelValorizaciones(dataContrato.idEfectorFacturacion, dataContrato.idTipoNomenclador, dataPorFecha))}
                handleGeneratePdf={(dataPorFecha) => dispatch(generatePDFValorizaciones(dataContrato.idEfectorFacturacion, dataContrato.idTipoNomenclador, dataPorFecha))}
              />
            </Grid>
            <Grid item xs={12}>
              <Card>
                <Table ref={componentRef}>
                  <TableHead>
                    <TableRow>
                      <TableCell padding="checkbox">
                        <Checkbox
                          indeterminate={selected.length > 0 && selected.length < nnxPracticasActivas.length}
                          checked={nnxPracticasActivas.length > 0 && selected.length === nnxPracticasActivas.length}
                          onChange={handleSelectAllClick}
                          inputProps={{ "aria-label": "select all desserts" }}
                          disabled={props.fieldsDisabled}
                        />
                      </TableCell>
                      <TableCell style={{ width: "5%" }}>
                        Codigo Practica
                      </TableCell>
                      <TableCell style={{ width: "50%" }}>
                        Nombre Practica
                      </TableCell>
                      <TableCell style={{ width: "10%" }}>Valor NNX</TableCell>
                      <TableCell style={{ width: "10%" }}>Valor Final</TableCell>
                      <TableCell style={{ width: "10%" }}>
                        Fecha Inicio Vigencia
                      </TableCell>
                      <TableCell style={{ width: "10%" }}>
                        Fecha Fin Vigencia
                      </TableCell>
                      {validarSoloUnPermiso(permisosUser, CONTRATACIONES_CONVENIOS_PERMISOS.ADMINISTRAR)
                       && selected.length > 0 && <TableCell>
                      <DeleteConveniosMasivosButton 
                      //fechaInicioVigencia={filtroFecha}
                      deletePracticas={deletePracticasActivasMasivasHandler}
                      futura={filtroFecha === 3} />
                      </TableCell>}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {nnxPracticasActivas?.slice(
                      page * rowsPerPage,
                      page * rowsPerPage + rowsPerPage
                    ).map((practica, index) => {
                      const isItemSelected = isSelected(practica.idValorizacion);
                      const labelId = `enhanced-table-checkbox-${index}`;

                      return (
                        <TableRow
                          key={index}
                            hover
                            role="checkbox"
                            aria-checked={isItemSelected}
                            tabIndex={-1}
                            selected={isItemSelected}
                            className={classes.rootTableRow}
                        >
                        <TableCell padding="checkbox">
                          <Checkbox
                            checked={isItemSelected}
                            inputProps={{ "aria-labelledby": labelId }}
                            onClick={(event) => handleClick(event, practica.idValorizacion)}
                            disabled={props.fieldsDisabled || (practica.fechaReactivacionPermitida !== null && moment(practica.fechaReactivacionPermitida).isSame(moment(), 'day'))}
                          />                              
                        </TableCell>
                          <TableCell>{practica.codigoPractica}</TableCell>
                          <TableCell>{practica.nombrePractica}</TableCell>
                          <TableCell>{practica.valorNnx}</TableCell>
                          <TableCell>${practica.valor}</TableCell>
                          <TableCell>
                            {new Date(
                              practica.fechaInicioVigencia
                            ).toLocaleDateString()}
                          </TableCell>
                          <TableCell>
                            {new Date(
                              practica.fechaFinVigencia
                            ).toLocaleDateString()}
                          </TableCell>
                          {!props.fieldsDisabled && (
                            <TableCell>
                              <div style={{ display: "flex" }}>
                                {
                                  !moment(practica.fechaFinVigencia).isBefore(moment(), 'day') &&
                                  <EditConveniosButton idItem={practica.idValorizacion} item={{ ...practica, valor: practica.valorNnx }} editItem={handleEditPractica} />
                                }
                                {
                                  (practica.fechaReactivacionPermitida !== null && moment(practica.fechaReactivacionPermitida).isSame(moment(), 'day'))
                                    ?
                                    <ReactivarConveniosButton idItem={practica.idValorizacion} reactivarPractica={reactivarPracticaHandler} />
                                    :
                                    <DeleteConveniosButton idItem={practica.idValorizacion} fechaInicioVigencia={practica.fechaInicioVigencia} deletePracticas={deletePracticasActivasHandler} futura={moment().isBefore(practica.fechaInicioVigencia)} />
                                }
                              </div>
                            </TableCell>
                          )}
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
                <TablePagination
                  component="div"
                  className="paginador"
                  count={nnxPracticasActivas.length}
                  rowsPerPageOptions={[20, 50, 100]}
                  labelRowsPerPage="Filas por página"
                  labelDisplayedRows={({ from, to, count }) =>
                    `${from}-${to} de ${count}`
                  }
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onChangePage={handleChangePage}
                  onChangeRowsPerPage={handleChangeRowsPerPage}
                  ActionsComponent={TablePaginationActions}
                />
              </Card>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </React.Fragment>
  );
};
